import { lazy } from 'react';
const IOUReversal = lazy(() => import('./IOUReversal'));

const IOUReversalRoutes = [
  {
    path: '/iou-reversal',
    component: IOUReversal
  }
];

export default IOUReversalRoutes;
